import React from "react";
import { Box, Tooltip, useTheme } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { RedemptionHow } from "../../../../../../models/Dashboard/Redemption/RedemptionSummary";

const formatHowTooltip = (how: RedemptionHow): string => {
  try {
    const info = how.info?.trim() || "";
    const fields = (how.fields || []).filter(Boolean);
    if (fields.length === 0) {
      return info;
    }
    const fieldsLine = `Fields: ${fields.join(", ")}`;
    return info ? `${info}\n\n${fieldsLine}` : fieldsLine;
  } catch (error) {
    console.error(error);
    return how.info || "";
  }
};

interface RedemptionHintProps {
  text?: string | null;
  how?: RedemptionHow | null;
  fontSize?: number;
}

/** i-icon tooltip. Prefer API `filter_info[].info` or `how` — do not invent copy. */
const RedemptionHint: React.FC<RedemptionHintProps> = ({
  text,
  how,
  fontSize = 16,
}) => {
  const theme = useTheme();

  const title = (() => {
    try {
      if (how) {
        return formatHowTooltip(how);
      }
      return (text || "").trim();
    } catch (error) {
      console.error(error);
      return "";
    }
  })();

  if (!title) {
    return null;
  }

  return (
    <Tooltip
      title={
        <Box sx={{ whiteSpace: "pre-wrap", maxWidth: 320, fontSize: "0.75rem", lineHeight: 1.45 }}>
          {title}
        </Box>
      }
      arrow
      placement="top"
      slotProps={{
        popper: {
          sx: {
            zIndex: (muiTheme) => muiTheme.zIndex.drawer + 5000,
          },
        },
      }}
    >
      <Box
        component="span"
        role="img"
        aria-label={title}
        onClick={(event) => event.stopPropagation()}
        onKeyDown={(event) => event.stopPropagation()}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          cursor: "help",
          color: theme.palette.customColors.greyTextColor,
          lineHeight: 0,
          flexShrink: 0,
        }}
      >
        <InfoOutlinedIcon sx={{ fontSize }} />
      </Box>
    </Tooltip>
  );
};

export default RedemptionHint;
